import React, { useState, useEffect } from "react";
import axios from "../../api/apiClient";
import ProjectTable from "./components/ProjectTable";
import LoadingSpinner from "./components/LoadingSpinner";
import ErrorAlert from "./components/ErrorAlert";
import SearchBar from "./components/SearchBar";
import { domain } from "../../function/FunctionApi";

const API_URL = domain + "/api/Admin/AllPrivateOrders";

const AllAdminPrivateProjects = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortConfig, setSortConfig] = useState({
    key: "orderDate",
    direction: "desc",
  });
  const [searchParams, setSearchParams] = useState({
    projectName: "",
    projectPlace: "",
    customer: "",
    consultant: "",
    branchName: "",
    district: "",
    contractor: "",
    stationNumber: "",
    workDescription: "",
  });

  const fetchProjects = async () => {
    try {
      setLoading(true);

      // Create params object with only non-empty search values
      const params = {};

      // Only add search parameters if they have values
      if (searchParams.projectName)
        params.ProjectName = searchParams.projectName;
      if (searchParams.projectPlace)
        params.ProjectPlace = searchParams.projectPlace;
      if (searchParams.customer) params.Customer = searchParams.customer;
      if (searchParams.consultant) params.Consultant = searchParams.consultant;
      if (searchParams.branchName) params.BranchName = searchParams.branchName;
      if (searchParams.district) params.District = searchParams.district;
      if (searchParams.contractor) params.Contractor = searchParams.contractor;
      if (searchParams.stationNumber)
        params.StationNumber = searchParams.stationNumber;
      if (searchParams.workDescription)
        params.WorkDescription = searchParams.workDescription;

      const response = await axios.get(API_URL, { params });

      if (response.data.statusCode === 200) {
        setProjects(response.data.data);
      } else {
        setError("Failed to fetch projects");
      }
    } catch (err) {
      setError(err.message || "An error occurred while fetching projects");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProjects();
  }, [searchParams]);

  const handleSearchChange = (name, value) => {
    setSearchParams((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSort = (key) => {
    setSortConfig((prevConfig) => ({
      key,
      direction:
        prevConfig.key === key && prevConfig.direction === "asc"
          ? "desc"
          : "asc",
    }));
  };

  const sortedProjects = [...projects].sort((a, b) => {
    if (sortConfig.key === "orderDate") {
      return sortConfig.direction === "asc"
        ? new Date(a.orderDate) - new Date(b.orderDate)
        : new Date(b.orderDate) - new Date(a.orderDate);
    }

    if (sortConfig.key === "projectValue") {
      return sortConfig.direction === "asc"
        ? parseFloat(a.projectValue) - parseFloat(b.projectValue)
        : parseFloat(b.projectValue) - parseFloat(a.projectValue);
    }

    return sortConfig.direction === "asc"
      ? a[sortConfig.key]?.localeCompare(b[sortConfig.key])
      : b[sortConfig.key]?.localeCompare(a[sortConfig.key]);
  });

  if (loading) {
    return <LoadingSpinner />;
  }

  if (error) {
    return <ErrorAlert message={error} />;
  }

  return (
    <div className="p-8">
      <h1 className="text-3xl font-bold text-gray-900 mb-6">المشاريع الخاصة</h1>
      <SearchBar
        searchParams={searchParams}
        onSearchChange={handleSearchChange}
      />
      <div className="bg-white rounded-lg shadow">
        <ProjectTable
          projects={sortedProjects}
          sortConfig={sortConfig}
          onSort={handleSort}
        />
      </div>
    </div>
  );
};

export default AllAdminPrivateProjects;
